import { fg } from '@atlassian/jira-feature-gating';

const isFieldsByIdRemoved = {
	get(): boolean {
		return fg('dfo_remove_fields_by_id');
	},
};

export default isFieldsByIdRemoved;
